import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                界
              </div>
              <span className="font-semibold text-base text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm leading-relaxed">
              {siteInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-3">内容分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-3">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                首页
              </Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                关于我们
              </Link>
              <a href={`mailto:${siteInfo.email}`} className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
                联系我们
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-3">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-background-50/60">
              <span>邮箱：{siteInfo.email}</span>
              <span>微信：{siteInfo.wechat}</span>
              <span>电话：{siteInfo.phone}</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} {siteInfo.name}. 保留所有权利。
          </p>
          <p className="text-xs text-background-50/40">
            专注婚姻社交边界，守护每一段珍贵的婚姻关系。
          </p>
        </div>
      </div>
    </footer>
  );
}